import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const OneWayIcon: FC<IconProps> = ({ width = 24, height = 24, ...rest }) => (
  <Icon type="OneWay" width={width} height={height} alt="OneWayIcon" ignoreRtl {...rest} />
)
